import { useCallback, useMemo } from 'react';
import { Button, Input } from 'reactstrap';
import PayoutStructureForm from './PayoutStructureForm';
import StandardLayout from '@/common/layouts/StandardLayout';
import { useNavigate } from 'react-router-dom';
import routes from '@/routes/routes-enums';
import { useSelector, useDispatch } from 'react-redux';
import { setName } from '@/redux/slices/payoutStructure';
import { AppState } from '@/redux/root';

const TournamentPayoutStructureForm = ({
  title,
  onDelete,
  onSubmit,
}: {
  title: string;
  onDelete?: () => void;
  onSubmit: (data: any) => void;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNameChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(setName(e.target.value));
    },
    [dispatch],
  );

  const { name, isDirty, validationErrors } = useSelector((state: AppState) => state.payoutStructure);

  const isValid = useMemo(() => {
    return !Object.keys(validationErrors).length && name;
  }, [validationErrors, name]);

  return (
    <div className="overflow-auto pb-4">
      <StandardLayout
        showBackButton
        pageTitle={title}
        onBackClick={() => navigate(routes.TOURNAMENT_PAYOUT_STRUCTURES)}
        headerButton={
          <div className="d-flex justify-content-center flex-row gap-2">
            {onDelete ? (
              <Button
                variant="danger"
                onClick={() => {
                  onDelete();
                }}
              >
                Delete
              </Button>
            ) : null}
            <Button onClick={onSubmit} color="primary" disabled={!isDirty || !isValid} type="submit">
              Save
            </Button>
          </div>
        }
      >
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Name <span className="text-danger">*</span>
          </label>
          <Input
            id="name"
            type="text"
            value={name}
            onChange={handleNameChange}
            className={validationErrors.name ? 'is-invalid' : ''}
          />
          {validationErrors.name && <div className="invalid-feedback">{validationErrors.name}</div>}
        </div>

        <PayoutStructureForm />
      </StandardLayout>
    </div>
  );
};

export default TournamentPayoutStructureForm;
